const iconWrapperClass = '.ExpandableListBlock__HeaderRight'
const iconClass = '.ExpandableListBlock__HeaderIcon'
const iconPlusClass = 'ExpandableListBlock__HeaderIconPlus';
const iconMinusClass = 'ExpandableListBlock__HeaderIconMinus';
const secionClass = '.ExpandableListBlock';
const itemsClass = '.ExpandableListBlock__Items'

function addSectionEventLister(targetSectionId = undefined) {
  const target = !!targetSectionId ? $(`#${targetSectionId}`) : $(document);
  target.find(iconWrapperClass).on('click', function(){
    const icon = $(this).find(iconClass);
    icon.toggleClass(iconPlusClass);
    icon.toggleClass(iconMinusClass);
    icon.parents(secionClass).find(itemsClass).slideToggle();
  });
};

$(function() {
  addSectionEventLister();
});

// エディタ用
$(document).on('shopify:section:load', function(event) {
  addSectionEventLister(event.target.id);
});
